import {getMappedProductAttributes} from '~/assets/js/utils/product_attributes_mapping'
import {formatDimensions} from 'assets/js/utils/format_dimensions'

export default {
  methods: {
    getColumnTitle: function (fieldName) {
      const column = this.tableColumns.find(c => c.field === fieldName)
      if (!column) {
        return
      }

      return column.title
    },
    getNestedValue: function (fieldName, dataItem) {
      const path = fieldName.split('.')
      let data = dataItem
      path.forEach((p) => {
        data = data ? data[p] : undefined
      })

      return data
    },
    getIndexPathValue: function (indexPath, dataItem, isExcelImport = false, defaultValue = null) {
      const locale = useNuxtApp().$i18n?.locale?.value || 'en'
      const res = getMappedProductAttributes([{Attribute: {IndexPath: indexPath}}], dataItem)
      if (!isExcelImport && res && res.length === 1) {
        let item = res[0]
        let formattedValue = null
        // eslint-disable-next-line eqeqeq
        if (item?.valueDouble != null) {
          formattedValue = formatDimensions(item?.valueDouble, locale, item.unitOfMeasure === 'inch')
        // eslint-disable-next-line eqeqeq
        } else if (item?.valueString != null) {
          formattedValue = item?.valueString
        } else if (item?.valueArrDouble?.length > 0) {
          const stringValues = item?.valueArrDouble.map(v => formatDimensions(v, locale, item.unitOfMeasure === 'inch'))
          formattedValue = stringValues.join(', ')
        } else if (item?.valueArrString?.length > 0) {
          formattedValue = item?.valueArrString.join(', ')
        } else {
          formattedValue = item?.value ?? item?.valueDec
        }
        return formattedValue ?? defaultValue
      }

      if (res && res.length === 1) {
        let item = res[0]
        let formattedValue = item?.valueDec !== null ? formatDimensions(item?.valueDec, locale, item.unit === 'inch') : item?.value
        return formattedValue ?? defaultValue
      }
      return defaultValue
    },
    getTranslatedIndexPathValue: function (indexPath, dataItem) {
      const res = getMappedProductAttributes([{Attribute: {IndexPath: indexPath}}], dataItem)
      if (res && res.length === 1) {
        let item = res[0]
        let shortName = indexPath.split('/')
        // eslint-disable-next-line eqeqeq
        if (item.valueDouble != null) {
          return item.valueDouble
        } else if (shortName.length === 2) {
          return this.$tv(item.valueString, 'attributes.' + shortName[1] + '-values')
        } else {
          return item.valueString
        }
      }
      return null
    },
    getTranslatedShortIndexPathValue: function (indexPath, dataItem) {
      const res = getMappedProductAttributes([{Attribute: {IndexPath: indexPath}}], dataItem)
      if (res && res.length === 1) {
        let item = res[0]
        let shortName = indexPath
        return this.$tv(item.value.toString(), 'attributes.' + shortName + '-values')
      }
      return null
    },
    getDate: function(fieldName, dataItem) {
      const data = this.getNestedValue(fieldName, dataItem)
      if (data) {
        if (Array.isArray(data)) {
          return data.length > 0 ? new Date(data[0].date) : null
        }
        return new Date(data)
      }
      return null
    }
  }
}
